import React, { useEffect, useState, useRef, useCallback } from "react";
import { Download } from "lucide-react";
import {
  DataGridPremium,
  GridToolbar,
  GridToolbarFilterButton,
  GridToolbarColumnsButton,
  GridToolbarContainer,
  GridToolbarQuickFilter,
} from "@mui/x-data-grid-premium";
import { read, utils, writeFile } from "xlsx";
import dayjs from "dayjs";
import _ from "lodash";
import { Button } from "../../components/ui/button";
import { DrawingDiscPDList, DPsubPDList, DPsubPD2List } from "../../utils/publicVar";

export const AFormTableList = ({ tabeldata }) => {
  const rows = tabeldata.map((v, index) => ({
    ...v,
    id: index + 1,
  }));

  const columns = [
    {
      field: "record_no",
      headerName: "레코드 번호",
      width: 100,
      editable: false,
    },
    {
      field: "DrawingDiscPD",
      headerName: "공종",
      width: 80,
      editable: false,
      type: "singleSelect",
      valueOptions: DrawingDiscPDList,
    },
    {
      field: "DPsubPD",
      headerName: "상세공종",
      width: 80,
      editable: false,
      type: "singleSelect",
      valueOptions: DPsubPDList,
    },
    {
      field: "DPsubPD2",
      headerName: "구분",
      width: 80,
      editable: false,
      type: "singleSelect",
      valueOptions: ({ row }) => {
        if (!row) {
          return DPsubPD2List;
        }
        return row.DPsubPD === "배관"
          ? ["모듈", "비모듈"]
          : row.DPsubPD === "HVAC"
            ? ["GAL'V", "GAL'V 외"]
            : ["-"];
      },
    },
    { field: "DPAreaBPK", headerName: "Area", width: 100, editable: false },
    { field: "DPFloor", headerName: "층", width: 100, editable: false },
    {
      field: "DrawingNo",
      headerName: "도면(문서) No",

      width: 180,
      editable: false,
    },
    {
      field: "DrawingName",
      headerName: "도면명",
      width: 350,
      editable: false,
    },
    { field: "DPRevNo", headerName: "리비전", width: 100, editable: false },
    {
      field: "MDModuleNoDPK",
      headerName: "모듈넘버",
      width: 100,
      editable: false,
    },
    {
      field: "WStart",
      headerName: "기준 날짜",
      type: "date",
      width: 100,
      editable: false,
    },
    {
      field: "VendorsDPK",
      headerName: "협력업체",
      width: 180,
      editable: false,
    },

    {
      field: "ReceiptPlanDate",
      headerName: "계획일",
      type: "date",
      width: 100,
      editable: false,
    },
    {
      field: "ReceiptActualDate",
      headerName: "실적일",
      type: "date",
      width: 100,
      editable: false,
    },

    {
      field: "CompletionPlanDate",
      headerName: "계획일",
      type: "date",
      width: 100,
      editable: false,
    },
    {
      field: "CompletionActualDate",
      headerName: "실적일",
      type: "date",
      width: 100,
      editable: false,
    },

    {
      field: "SubmissionPlanDate",
      headerName: "계획일",
      type: "date",
      width: 100,
      editable: false,
    },
    {
      field: "SubmissionActualDate",
      headerName: "실적일",
      type: "date",
      width: 100,
      editable: false,
    },
    {
      field: "SubmissionGap",
      headerName: "GAP",
      type: "number",
      width: 80,
      editable: false,
    },

    {
      field: "ApprovalPlanDate",
      headerName: "계획일",
      type: "date",
      width: 100,
      editable: false,
    },
    {
      field: "ApprovalActualDate",
      headerName: "실적일",
      type: "date",
      width: 100,
      editable: false,
    },
    {
      field: "ApprovalGap",
      headerName: "GAP",
      type: "number",
      width: 100,
      editable: false,
    },

    {
      field: "IssuePlanDate",
      headerName: "계획일",
      type: "date",
      width: 100,
      editable: false,
    },
    {
      field: "IssueActualDate",
      headerName: "실적일",
      type: "date",
      width: 100,
      editable: false,
    },
    {
      field: "IssueGap",
      headerName: "GAP",
      type: "number",
      width: 100,
      editable: false,
    },
  ];

  const columnGroupingModel = [
    {
      groupId: "사전검토",
      children: [
        {
          groupId: "접수(시공사→설계사)",
          children: [{ field: "ReceiptPlanDate" }, { field: "ReceiptActualDate" }],
        },
        {
          groupId: "완료(설계사→시공사)",
          children: [{ field: "CompletionPlanDate" }, { field: "CompletionActualDate" }],
        },
      ],
    },
    {
      groupId: "CPMS",
      children: [
        {
          groupId: "상신",
          children: [
            { field: "SubmissionPlanDate" },
            { field: "SubmissionActualDate" },
            { field: "SubmissionGap" },
          ],
        },
        {
          groupId: "승인",
          children: [
            { field: "ApprovalPlanDate" },
            { field: "ApprovalActualDate" },
            { field: "ApprovalGap" },
          ],
        },
      ],
    },
    {
      groupId: "도면 ISSUE",
      children: [{ field: "IssuePlanDate" }, { field: "IssueActualDate" }, { field: "IssueGap" }],
    },
  ];

  const downloadExcel = () => {
    function generateHeaders(data) {
      const topHeaders = [];
      const middleHeaders = [];
      const bottomHeaders = [];

      // Assuming all rows have the same keys, use the first row to determine headers
      const keys = Object.keys(data[0] || {});

      keys.forEach((key) => {
        const parts = key.split("//");

        // Check the number of parts and assign accordingly
        if (parts.length === 1) {
          // No '//' in key
          topHeaders.push("");
          middleHeaders.push("");
          bottomHeaders.push(parts[0]);
        } else if (parts.length === 2) {
          // One '//' in key
          topHeaders.push(parts[0]);
          middleHeaders.push("");
          bottomHeaders.push(parts[1]);
        } else if (parts.length === 3) {
          // Two '//' in key
          topHeaders.push(parts[0]);
          middleHeaders.push(parts[1]);
          bottomHeaders.push(parts[2]);
        }
      });

      return { topHeaders, middleHeaders, bottomHeaders };
    }

    const initialData = rows.map((v) => ({
      "레코드 번호": v.record_no,
      공종: v.DrawingDiscPD,
      상세공종: v.DPsubPD,
      구분: v.DPsubPD2,
      Area: v.DPAreaBPK,
      층: v.DPFloor,
      "도면(문서) No": v.DrawingNo,
      도면명: v.DrawingName,
      리비전: v.DPRevNo,
      모듈넘버: v.MDModuleNoDPK,
      "기준 날짜": v.WStart,
      협력업체: v.VendorsDPK,

      "사전검토//접수(시공사→설계사)//계획일": v.ReceiptPlanDate,
      "사전검토//접수(시공사→설계사)//실적일": v.ReceiptActualDate,
      "사전검토//완료(설계사→시공사)//계획일": v.CompletionPlanDate,
      "사전검토//완료(설계사→시공사)//실적일": v.CompletionActualDate,

      "CPMS//상신//계획일": v.SubmissionPlanDate,
      "CPMS//상신//실적일": v.SubmissionActualDate,
      "CPMS//상신//GAP": v.SubmissionGap,

      "CPMS//승인//계획일": v.ApprovalPlanDate,
      "CPMS//승인//실적일": v.ApprovalActualDate,
      "CPMS//승인//GAP": v.ApprovalGap,

      "도면 ISSUE//계획일": v.IssuePlanDate,
      "도면 ISSUE//실적일": v.IssueActualDate,
      "도면 ISSUE//GAP": v.IssueGap,
    }));

    const { topHeaders, middleHeaders, bottomHeaders } = generateHeaders(initialData);
    const worksheet = utils.aoa_to_sheet([topHeaders, middleHeaders, bottomHeaders]);

    // Find and merge cells with the same value in the top header
    let currentMerge = null;
    topHeaders.forEach((header, index) => {
      if (header !== "" && (index === 0 || topHeaders[index - 1] !== header)) {
        currentMerge = { s: { r: 0, c: index }, e: { r: 0, c: index } };
      }
      if (header !== "" && (index === topHeaders.length - 1 || topHeaders[index + 1] !== header)) {
        if (currentMerge) {
          currentMerge.e.c = index;
          if (!worksheet["!merges"]) worksheet["!merges"] = [];
          worksheet["!merges"].push(currentMerge);
        }
      }
    });

    // Find and merge cells with the same value in the middle header
    let currentMergeMiddle = null;
    middleHeaders.forEach((header, index) => {
      if (header !== "" && (index === 0 || middleHeaders[index - 1] !== header)) {
        currentMergeMiddle = { s: { r: 1, c: index }, e: { r: 1, c: index } }; // Start of new merge range in row 1
      }
      if (
        header !== "" &&
        (index === middleHeaders.length - 1 || middleHeaders[index + 1] !== header)
      ) {
        if (currentMergeMiddle) {
          currentMergeMiddle.e.c = index; // End of merge range
          if (!worksheet["!merges"]) worksheet["!merges"] = [];
          worksheet["!merges"].push(currentMergeMiddle);
        }
      }
    });

    const keysArray = Object.keys(initialData[0] || {});
    const dataRows = initialData.map((row) => keysArray.map((fieldName) => row[fieldName] || ""));
    utils.sheet_add_json(worksheet, dataRows, { origin: -1, skipHeader: true });

    const workbook = utils.book_new();
    utils.book_append_sheet(workbook, worksheet, "Sheet1");
    writeFile(workbook, `승인도_${dayjs().format("YYYYMMDDHHmmss")}.xlsx`);
  };

  function CustomToolbar() {
    const gridButtonSx = {
      textTransform: "none",
      borderRadius: 0,
      backgroundColor: "hsl(var(--background))",
      color: "hsl(var(--foreground))",
      borderRight: "1px solid hsl(var(--border))",
      fontSize: "0.75rem",
      "&:hover": {
        backgroundColor: "hsl(var(--accent))",
      },
      "& .MuiButton-startIcon": {
        display: "none",
      },
    };
    const groupButtonClassName =
      "rounded-none border-0 border-r border-border shadow-none last:border-r-0";

    return (
      <GridToolbarContainer>
        <GridToolbarQuickFilter
          variant="outlined"
          size="small"
          sx={{
            minWidth: 180,
            paddingBottom: 0,
            fontSize: "0.75rem",
            "& .MuiOutlinedInput-root": {
              borderRadius: "calc(var(--radius) - 2px)",
              backgroundColor: "hsl(var(--background))",
              fontSize: "0.75rem",
            },
            "& .MuiOutlinedInput-notchedOutline": {
              borderColor: "hsl(var(--border))",
            },
          }}
        />
        <div
          style={{
            display: "flex",
            gap: "10px",
            alignItems: "center",
            position: "absolute",
            right: 8,
          }}
        >
          <div
            style={{
              display: "flex",
              gap: "10px",
              alignItems: "center",
              justifyContent: "flex-end",
            }}
          >
            <div className="inline-flex rounded-md shadow-[0_0_0_1px_hsl(var(--border))] overflow-hidden">
              <GridToolbarColumnsButton slotProps={{ button: { sx: gridButtonSx } }} />
              <GridToolbarFilterButton slotProps={{ button: { sx: gridButtonSx } }} />
              <Button
                variant="outline"
                size="sm"
                className={`${groupButtonClassName} text-xs`}
                onClick={downloadExcel}
              >
                <Download className="h-4 w-4" />
                다운로드
              </Button>
            </div>
          </div>
        </div>
      </GridToolbarContainer>
    );
  }

  return (
    <>
      <div className="flex h-full min-h-0 w-full flex-col">
        {/* <Button startIcon={<DownloadIcon />} size="small" onClick={downloadExcel}>
        다운로드
      </Button> */}
        <div className="flex-1 min-h-0 w-full rounded-lg border border-border overflow-hidden shadow-sm [&_.actions]:text-muted-foreground [&_.textPrimary]:text-foreground [&_.cold]:bg-[#b9d5ff91] [&_.cold]:text-[#1a3e72] [&_.hot]:bg-[#ff943975] [&_.hot]:text-[#1a3e72]">
          <DataGridPremium
            rows={rows}
            density="compact"
            columns={columns}
            pagination
            localeText={{ toolbarColumns: "컬럼", toolbarFilters: "필터" }}
            experimentalFeatures={{ columnGrouping: true }}
            columnGroupingModel={columnGroupingModel}
            slots={{
              toolbar: CustomToolbar,
            }}
            getCellClassName={(params) => {
              if (
                (params.field === "IssueGap" ||
                  params.field === "ApprovalGap" ||
                  params.field === "SubmissionGap") &&
                params.value !== null &&
                params.value !== 0
              ) {
                return params.value >= 0 ? "cold" : "hot";
              }
            }}
            sx={{
              "& .MuiDataGrid-columnHeader .MuiSvgIcon-root, & .MuiDataGrid-cell .MuiSvgIcon-root, & .MuiCheckbox-root .MuiSvgIcon-root":
                {
                  fontSize: "1rem",
                },
              "& .MuiDataGrid-columnHeaderTitle, & .MuiDataGrid-cell": {
                fontSize: "0.75rem",
              },
              "& .MuiDataGrid-toolbarContainer": {
                backgroundColor: "hsl(var(--background))",
              },
            }}
          />
        </div>
      </div>
    </>
  );
};
